import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const normalize = (opts = []) =>
  opts.map((o) => (typeof o === "string" ? { value: o, label: o } : o));

const CustomDropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select option",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const items = normalize(options);
  const selectedLabel =
    items.find((o) => String(o.value) === String(value))?.label || placeholder;

  // close when clicking outside
  useEffect(() => {
    const onClickAway = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", onClickAway);
    return () => document.removeEventListener("mousedown", onClickAway);
  }, [open]);

  return (
    <div ref={ref} className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-left text-xs text-[#1d2951] focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none flex items-center justify-between"
      >
        <span className={`${value ? "" : "text-gray-400"}`}>
          {selectedLabel}
        </span>
        {open ? (
          <KeyboardArrowUpIcon fontSize="small" className="text-gray-500" />
        ) : (
          <KeyboardArrowDownIcon fontSize="small" className="text-gray-500" />
        )}
      </button>

      {open && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-auto text-xs">
          {items.map((opt) => (
            <li
              key={String(opt.value)}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className="cursor-pointer px-3 py-2 hover:bg-[#E17954] hover:text-[#fff] text-[#1d2951]"
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
